import { useState } from 'react'
import { Link } from 'react-router';
import parse from "html-react-parser"
import { formatDate } from '../utilities/utilities';

//<p><span className="link">{ parse( b.title || '' ) }</span></p>

export default function Links( props ) {

	const [ more, setMore ] = useState( false )

	if ( !props.category || !props.category.rows ) return false

	//console.log( 'Links', props.category )

	return <>
		{ props.category.rows.map( ( b, j ) => { 
			if ( !more && ( j > 4 ) ) return false
			return (
				<Link key={ b + j } to={ '/' + props.category.path + '/' + b.id } >
    				<div className="link">
    					<div 
    						style={{ 
								position:'absolute', left:0, 
								top:'50%', transform:'translateY(-50%)', 
								padding:'5px 10px 5px 10px', 
							}} 
						>
	    					{ b.title && <>{ parse( b.title || '' ) }</> }
	    					{ ( b.route || b.first_day ) && <>
		    					<br/><span style={{ fontWeight:500 }} >
		    						{ b.route && <>{ parse( b.route || '' ) } <br/></> }
		    						{ b.first_day && <>{ formatDate( b.first_day ) } - { formatDate( b.last_day ) }</> }
								</span>
							</> }
	    				</div>

    					<div 
				            className="material-symbols-outlined" 
    						style={{ 
								position:'absolute', right:0, 
								top:'50%', transform:'translateY(-50%)', 
								padding:'5px 10px 5px 0', 
							}} 
						>
    						arrow_forward
	    				</div>
    				</div>
					
    			</Link>
			) 
		} ) }
		{ props.links && props.links.length > 5 && 
		<button
			className="button"
			onClick={ e => setMore( !more ) }
		>
			{ !more ? "Show more" : "Show less" }
		</button>
		}
	</>
}
